/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { Palette, Tokens } from '@jda/lui-common-component-library-mui5';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    overflow: "hidden",
    position: "relative",
    margin: theme.spacing(0, 2),
  },
  card: {
    '& .MuiCardContent-root:last-child': {
      paddingBottom: 0,
    }
  },
  backIcon: {
    width: Tokens.spacing['$sp-12'],
    height: Tokens.spacing['$sp-12'],
    color: theme.palette.text.primary,
  },
  appBarWrap: {
    display: "flex",
    flexDirection: "row",
    background: 'transparent !important',
  },
  headingAlignment: {
    color: theme.palette.text.primary,
    fontSize: Tokens.spacing['$sp-8-5'],
    marginBottom: Tokens.spacing['$sp-4']
  },
  tabPanel: {
    margin: Tokens.spacing['$sp-8-5'],
  },
  heading: {
    color: theme.palette.text.secondary
  },
  machineNameInputContent: {
    width: Tokens.spacing['$sp-66-5'],
    display: 'flex',
    alignItems: 'flex-end',
    
  },
  loader : {
        width: Tokens.spacing['$sp-5'],  
    },
  machineInput: {
    marginRight: Tokens.spacing['$sp-4']
  },
  contentContainer: {
    marginTop: Tokens.spacing['$sp-4']
  },
  rolesContainer: {
    
  },
  elevate: {
    display: 'flex',
    '& > *': {
      marginRight: Tokens.spacing['$sp-4'],
      marginTop: Tokens.spacing['$sp-4'],
      marginBottom: Tokens.spacing['$sp-4'],
      borderRadius: Tokens.spacing['$sp-1'],
      boxSizing: "border-box",
    },
  },
  paddingStyler: {
    fontWeight: 500,
    fontSize: Tokens.spacing['$sp-4'],
  },
  expiry: {
    color: theme.palette.text.secondary
  },
  paddingStylerDelete: {
  },
  addSecretPaper: {
    display: 'flex',
    padding: Tokens.spacing['$sp-2'],
    borderColor: theme.palette.divider,
  },
  addSecretBox: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: Tokens.spacing['$sp-66-5']
  },
  addSecretKeyBox: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    minWidth: Tokens.spacing['$sp-66-5'],
  },
  editorContainer: {
    height: '190px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: '8px',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '4px',
    marginBottom: Tokens.spacing['$sp-4'],
  },
  copyButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    height: '40px',
    alignItems: 'center',
     borderBottom: `1px solid ${theme.palette.divider}`,
    '& #display-content-id': {
      marginRight: Tokens.spacing['$sp-2']
    },
   
   
  },
  editor: {
    width: '100%',
    height: '100px',
  },
  toolbarPanel : {
    padding:  Tokens.spacing['$sp-3']
  },
  toolbarButtonPanel: {
    '& > :not(:last-child)': {
      marginRight: Tokens.spacing['$sp-1']
    }
  },
  emptyComponentWrapper: {
    height: '500px'
  },
  alertMsg: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: Tokens.spacing['$sp-3-5']
  },
  warningIcon: {
    marginRight: 10,
  },
  secretHederBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  content: {
    marginRight: Tokens.spacing['$sp-2'],
  },
  valueContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  tabBoxMain: {
    display: "flex",
    flexDirection: "column",
  },
  tabTextStyle: {
    alignItems: 'flex-start',
    marginLeft: Tokens.spacing['$sp-2'],
  },
  tabs: {
    borderBottomStyle: 'none',
    width: Tokens.spacing['$sp-51-5'],
    padding: Tokens.spacing['$sp-3'],
    backgroundColor: theme.palette.mode === 'light' ? Palette.FractalUI.light.steel[2] : Palette.FractalUI.dark.steel[2],
  },
  tabWrapperCard: {
    padding: Tokens.spacing['$sp-3'],
    borderRadius: Tokens.spacing['$sp-2'],
  },
  cardHeader : {
    h2: {
      marginRight: Tokens.spacing['$sp-2'],
    },
    display: 'flex',
    alignItems: 'center',
  },
  uberTag: {
    '& .MuiChip-root.MuiChip-outlined' : {
      backgroundColor: 'transparent',
    },
  },
  curlNote: {
    '& div': {
      marginBottom: Tokens.spacing['$sp-1'],
    },
  },
  example: {
    fontWeight: 500,
  },
  domain: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      marginLeft: Tokens.spacing['$sp-1'],
      marginRight: Tokens.spacing['$sp-1'],
    }
  }
}));
